import { FormControl, ValidatorFn } from "@angular/forms";
import {ActivatedRouteSnapshot, DetachedRouteHandle, BaseRouteReuseStrategy} from '@angular/router';


export function enableFormControl(formControl: FormControl, withDefaultValue:string | string [], validators: ValidatorFn | ValidatorFn[]){
    formControl.enable();
    formControl.setValidators(validators);
    formControl.updateValueAndValidity();
    formControl.patchValue(withDefaultValue);
  }

export function disableFormControl(formControl: FormControl, withDefaultValue:string | string []){
    formControl.clearValidators();
    formControl.updateValueAndValidity();
    formControl.patchValue(withDefaultValue);
    formControl.disable();
  }

  export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  
    public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
      return (future.routeConfig === curr.routeConfig) || future.data['reuseComponent'];
    }
    
  }
